import { apiFetch } from "@/utils";

function logGeneratedFicheRdv(frsGuid, year) {
  return apiFetch("cdm/generated-fiche-rdv?frsGuid=" + frsGuid + "&year=" + year);
}

function getAllUsers() {
  return apiFetch("cdm/allusers");
}


export default {
  logGeneratedFicheRdv,
  getAllUsers
}
export {
  logGeneratedFicheRdv,
  getAllUsers
}



// WEBPACK FOOTER //
// ./src/utils/cdm.js